import { FeedbackRounded } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { StyledReportButton } from '../../styles/HeaderStyles'

function ReportButton(admin: { admin?: boolean }) {
  const { t } = useTranslation(['global'])

  const handleClick = () => window.open('https://drv.es/reportar-error-en-plei/')

  return (
    <Tooltip title={`${t('report-a-problem')}`}>
      <StyledReportButton
        variant="text"
        color="secondary"
        className={admin ? 'admin' : ''}
        startIcon={<FeedbackRounded style={{ fontSize: 20 }} />}
        aria-controls="share-link-menu"
        aria-haspopup="false"
        onClick={handleClick}
      >
        {t('report')}
      </StyledReportButton>
    </Tooltip>
  )
}

export default ReportButton
